import React from 'react'

const Pytm6 = () => {
    return (
        <div className='container'>
        <h1>Check if two trees are Mirror</h1>
        <p>Given two Binary Trees, write a function that returns true if two trees are mirror of each other, else false. </p>
        <p>This problem is different from the problem discussed here.<br/>
        For two trees ‘a’ and ‘b’ to be mirror images, the following three conditions must be true:&nbsp;<br/>
        &nbsp;</p>
        <ol><li>Their root node’s key must be same</li>
        <li>Left subtree of root of ‘a’ and right subtree root of ‘b’ are mirror.</li>
        <li>Right subtree of ‘a’ and left subtree of ‘b’ are mirror.</li>
        </ol>

    <div class="tabs">
       <input type="radio" name="tab" id="tab1" />
       <label for="tab1">CPP</label>
       <input type="radio" name="tab" id="tab2"/>
       <label for="tab2">Java </label>
       <input type="radio" name="tab" id="tab3"/>
       <label for="tab3">Python</label>

   
     
       <div class="tab-content-wrapper">
         <div id="tab-content-1" class="tab-content">
         <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// C++ program to check if two trees are mirror</code>
</div>
<div class="line number2 index1 alt1"><code class="comments">// of each other</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments">/* A binary tree node has data, pointer to</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">left child and a pointer to right child */</code></div>
<div class="line number8 index7 alt1"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* left, *right;</code></div>
<div class="line number12 index11 alt1"><code class="plain">&#125;;</code></div>
<div class="line number13 index12 alt2">&nbsp;</div>
<div class="line number14 index13 alt1"><code class="comments">/* Given two trees, return true if they are</code>
</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">mirror of each other */</code></div>
<div class="line number16 index15 alt1"><code class="color1 bold">int</code> <code
        class="plain">areMirror(Node* a, Node* b)</code></div>
<div class="line number17 index16 alt2"><code class="plain">&#123;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Base case : Both empty */</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a==NULL &amp;&amp; b==NULL)</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="keyword bold">true</code><code class="plain">;</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If only one is empty</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a==NULL || b == NULL)</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="keyword bold">false</code><code class="plain">;</code></div>
<div class="line number25 index24 alt2">&nbsp;</div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Both non-empty, compare them recursively</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Note that in recursive calls, we pass left</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">of one tree and right of other tree */</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code>&nbsp; <code class="plain">a-&gt;data == b-&gt;data &amp;&amp;</code>
</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">areMirror(a-&gt;left, b-&gt;right) &amp;&amp;</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">areMirror(a-&gt;right, b-&gt;left);</code></div>
<div class="line number32 index31 alt1"><code class="plain">&#125;</code></div>
<div class="line number33 index32 alt2">&nbsp;</div>
<div class="line number34 index33 alt1"><code
        class="comments">/* Helper function that allocates a new node */</code></div>
<div class="line number35 index34 alt2"><code class="plain">Node* newNode(</code><code
        class="color1 bold">int</code> <code class="plain">data)</code></div>
<div class="line number36 index35 alt1"><code class="plain">&#123;</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* node = </code><code class="keyword bold">new</code> <code class="plain">Node;</code>
</div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node-&gt;data&nbsp; = data;</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node-&gt;left&nbsp; =&nbsp; node-&gt;right&nbsp; = NULL;</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">(node);</code></div>
<div class="line number41 index40 alt2"><code class="plain">&#125;</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code class="comments">/* Driver program to test areMirror() */</code></div>
<div class="line number44 index43 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number45 index44 alt2"><code class="plain">&#123;</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node *a = newNode(1);</code></div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node *b = newNode(1);</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a-&gt;left = newNode(2);</code></div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a-&gt;right = newNode(3);</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a-&gt;left-&gt;left&nbsp; = newNode(4);</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a-&gt;left-&gt;right = newNode(5);</code></div>
<div class="line number52 index51 alt1">&nbsp;</div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b-&gt;left = newNode(3);</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b-&gt;right = newNode(2);</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b-&gt;right-&gt;left = newNode(5);</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b-&gt;right-&gt;right = newNode(4);</code></div>
<div class="line number57 index56 alt2">&nbsp;</div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">areMirror(a, b)? cout &lt;&lt; </code><code class="string">"Yes"</code> <code
        class="plain">: cout &lt;&lt; </code><code class="string">"No"</code><code class="plain">;</code></div>
<div class="line number59 index58 alt2">&nbsp;</div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number61 index60 alt2"><code class="plain">&#125;</code></div>
</div>
       </div>
         <div id="tab-content-2" class="tab-content">
         <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Java program to see if two trees</code></div>
<div class="line number2 index1 alt1"><code class="comments">// are mirror of each other</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments">// A binary tree node</code></div>
<div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">Node</code></div>
<div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">data;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node left, right;</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="plain">Node(</code><code class="keyword">int</code> <code
        class="plain">data)</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">this</code><code class="plain">.data = data;</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">left = right = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number15 index14 alt2"><code class="plain">&#125;</code></div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2"><code class="keyword">class</code> <code class="plain">BinaryTree</code>
</div>
<div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node a, b;</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Given two trees, return true if they are</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">mirror of each other */</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">boolean</code> <code class="plain">areMirror(Node a, Node b)</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Base case : Both empty */</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(a == </code><code class="keyword">null</code> <code
        class="plain">&amp;&amp; b == </code><code class="keyword">null</code><code class="plain">)</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="keyword">true</code><code class="plain">;</code></div>
<div class="line number28 index27 alt1">&nbsp;</div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If only one is empty</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(a == </code><code class="keyword">null</code> <code
        class="plain">|| b == </code><code class="keyword">null</code><code class="plain">)</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="keyword">false</code><code class="plain">;</code></div>
<div class="line number32 index31 alt1">&nbsp;</div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Both non-empty, compare them recursively</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Note that in recursive calls, we pass left</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">of one tree and right of other tree */</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">a.data == b.data</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&amp;&amp; areMirror(a.left, b.right)</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&amp;&amp; areMirror(a.right, b.left);</code></div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Driver code to test above methods</code></div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String[] args)</code></div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">BinaryTree tree = </code><code class="keyword">new</code> <code
        class="plain">BinaryTree();</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node a = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">1</code><code class="plain">);</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node b = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">1</code><code class="plain">);</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">2</code><code class="plain">);</code></div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a.right = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">3</code><code class="plain">);</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a.left.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">4</code><code class="plain">);</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">a.left.right = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">5</code><code class="plain">);</code></div>
<div class="line number51 index50 alt2">&nbsp;</div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">3</code><code class="plain">);</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b.right = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">2</code><code class="plain">);</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b.right.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">5</code><code class="plain">);</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b.right.right = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">4</code><code class="plain">);</code></div>
<div class="line number56 index55 alt1">&nbsp;</div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(tree.areMirror(a, b) == </code><code
        class="keyword">true</code><code class="plain">)</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Yes"</code><code class="plain">);</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"No"</code><code class="plain">);</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number63 index62 alt2"><code class="plain">&#125;</code></div>
<div class="line number64 index63 alt1">&nbsp;</div>
<div class="line number65 index64 alt2"><code
        class="comments">// This code has been contributed by Mayank Jaiswal(mayank_24)</code></div>
</div>
             </div>
         <div id="tab-content-3" class="tab-content"> 
         <div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python3 program to check if two</code></div>
<div class="line number2 index1 alt1"><code class="comments"># trees are mirror of each other</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments"># A binary tree node</code></div>
<div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">Node:</code></div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">, data):</code></div>
<div class="line number7 index6 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
        class="plain">data</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.left </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.right </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number10 index9 alt1">&nbsp;</div>
<div class="line number11 index10 alt2"><code class="comments"># Given two trees, return true</code></div>
<div class="line number12 index11 alt1"><code class="comments"># if they are mirror of each other</code></div>
<div class="line number13 index12 alt2"><code class="keyword">def</code> <code class="plain">areMirror(a, b):</code>
</div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Base case : Both empty</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">a </code><code class="keyword">is</code> <code
        class="color1">None</code> <code class="keyword">and</code> <code class="plain">b </code><code
        class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="color1">True</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># If only one is empty</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">a </code><code class="keyword">is</code> <code
        class="color1">None</code> <code class="keyword">or</code> <code class="plain">b </code><code
        class="keyword">is</code> <code class="color1">None</code><code class="plain">:</code></div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="color1">False</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Both non-empty, compare them</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># recursively. Note that in</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># recursive calls, we pass left</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># of one tree and right of other tree</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(a.data </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="plain">b.data </code><code class="keyword">and</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">areMirror(a.left, b.right) </code><code class="keyword">and</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">areMirror(a.right , b.left))</code></div>
<div class="line number30 index29 alt1">&nbsp;</div>
<div class="line number31 index30 alt2"><code class="comments"># Driver code</code></div>
<div class="line number32 index31 alt1"><code class="plain">root1 </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">1</code><code class="plain">)</code></div>
<div class="line number33 index32 alt2"><code class="plain">root2 </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">1</code><code class="plain">)</code></div>
<div class="line number34 index33 alt1">&nbsp;</div>
<div class="line number35 index34 alt2"><code class="plain">root1.left </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">2</code><code class="plain">)</code></div>
<div class="line number36 index35 alt1"><code class="plain">root1.right </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">3</code><code class="plain">)</code></div>
<div class="line number37 index36 alt2"><code class="plain">root1.left.left </code><code class="keyword">=</code>
    <code class="plain">Node(</code><code class="value">4</code><code class="plain">)</code></div>
<div class="line number38 index37 alt1"><code class="plain">root1.left.right </code><code class="keyword">=</code>
    <code class="plain">Node(</code><code class="value">5</code><code class="plain">)</code></div>
<div class="line number39 index38 alt2">&nbsp;</div>
<div class="line number40 index39 alt1"><code class="plain">root2.left </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">3</code><code class="plain">)</code></div>
<div class="line number41 index40 alt2"><code class="plain">root2.right </code><code class="keyword">=</code> <code
        class="plain">Node(</code><code class="value">2</code><code class="plain">)</code></div>
<div class="line number42 index41 alt1"><code class="plain">root2.right.left </code><code class="keyword">=</code>
    <code class="plain">Node(</code><code class="value">5</code><code class="plain">)</code></div>
<div class="line number43 index42 alt2"><code class="plain">root2.right.right </code><code class="keyword">=</code>
    <code class="plain">Node(</code><code class="value">4</code><code class="plain">)</code></div>
<div class="line number44 index43 alt1">&nbsp;</div>
<div class="line number45 index44 alt2"><code class="keyword">if</code> <code
        class="plain">areMirror(root1, root2):</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code> <code class="plain">(</code><code class="string">"Yes"</code><code
        class="plain">)</code></div>
<div class="line number47 index46 alt2"><code class="keyword">else</code><code class="plain">:</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code> <code class="plain">(</code><code class="string">"No"</code><code
        class="plain">)</code></div>
<div class="line number49 index48 alt2">&nbsp;</div>
<div class="line number50 index49 alt1"><code class="comments"># This code is contributed by AshishR</code></div>
</div>
      </div>
     
        </div>
     </div>
     <br /> <br /> <br /> <br /> <br />
           </div>
    )
}

export default Pytm6
